import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import momentPropTypes from 'react-moment-proptypes';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ActionCode from 'material-ui/svg-icons/action/code';
import PostalOperatorSelectionSidebarContainer
  from '../../target-node-unlocode-selector/containers/PostalOperatorUnlocodeSelectionSidebarContainer';
import ProgressButtons from './ProgressButtons';
import {
  getArrivalCheckedUnlocodes,
  getArrivalPostalOperators,
  getDepartureCheckedUnlocodes,
  getDeparturePostalOperators,
  getExpandedArrivalPostalOperators,
  getExpandedDeparturePostalOperators,
  getSelectedArrivalPostalOperators,
  getSelectedDeparturePostalOperators,
  getDirections,
  getIsDirectionsSwitched,
} from '../../target-node-unlocode-selector/redux/selectors/PostalOperatorSelectors';
import SaveUnlocodeSelectionModal from '../../target-node-unlocode-selector/components/SaveUnlocodeSelectionModal';
import { saveUserUnlocodeSelectionRequestActionCreator } from '../../../user/redux/actions/UserActions';
import PostalOperatorSelector from '../../target-node-unlocode-selector/components/PostalOperatorUnlocodeSelector';
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from '../../period-selector/redux/selectors/PeriodSelectionSelectors';
import {
  departureUnlocodeCheckedActionCreator,
  onDeparturePostalOperatorExpanded,
  onDeSelectAllDepartureUnlocodes,
  onSelectAllDepartureUnlocodes,
  retrieveOutboundPostalOperatorsUnlocodeRequestActionCreator,
} from '../../target-node-unlocode-selector/redux/actions/DeparturePostalOperatorActions';
import {
  arrivalUnlocodeCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onDeSelectAllArrivalUnlocodes,
  onSelectAllArrivalUnlocodes,
  retrieveInboundPostalOperatorsUnlocodeRequestActionCreator,
} from '../../target-node-unlocode-selector/redux/actions/ArrivalPostalOperatorActions';
import {
  setDirections,
  setDirectionFlag,
  switchDepartureArrival,
} from '../../target-node-unlocode-selector/redux/actions/PostalOperatorActions';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import * as LocationTypes from '../../../common/redux/actions/types/LocationTypes';
import sc from '../../../common/redux/actions/types/SelectionCriteriaTypes';
import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';
import DirectionTypes from '../../../common/redux/actions/types/DirectionTypes';
import noop from "../../../../core/modules/common/tools/noop";
import { createUnlocodePresetSelectionsOnSave } from "../../../react-table/helpers/utils";

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundPostalOperatorsUnlocodeRequestActionCreator,
  retrieveInboundPostalOperatorsUnlocodeRequestActionCreator,
  saveUserUnlocodeSelectionRequestActionCreator,
  departureUnlocodeCheckedActionCreator,
  onDeparturePostalOperatorExpanded,
  onSelectAllDepartureUnlocodes,
  onDeSelectAllDepartureUnlocodes,
  arrivalUnlocodeCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onSelectAllArrivalUnlocodes,
  onDeSelectAllArrivalUnlocodes,
  setDirections,
  switchDepartureArrival,
  getIsDirectionsSwitched,
  setDirectionFlag,
}, dispatch);

const mapStateToProps = state => ({
  selectedDeparturePostalOperatorsNodes: getSelectedDeparturePostalOperators(state),
  departurePostalOperatorsNodes: getDeparturePostalOperators(state),
  departureCheckedUnlocodes: getDepartureCheckedUnlocodes(state),
  departureExpandedPostalOperators: getExpandedDeparturePostalOperators(state),
  selectedArrivalPostalOperatorsNodes: getSelectedArrivalPostalOperators(state),
  arrivalPostalOperatorsNodes: getArrivalPostalOperators(state),
  arrivalCheckedUnlocodes: getArrivalCheckedUnlocodes(state),
  arrivalExpandedPostalOperators: getExpandedArrivalPostalOperators(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
  directions: getDirections(state),
  isDirectionsSwitched: getIsDirectionsSwitched(state),
});

class TargetNodeUnlocodeWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstDeparture: true,
      firstArrival: true,
      departureSelectionTreeLoaded: false,
      arrivalSelectionTreeLoaded: false,
      showOnlySelectedDeparturePostalOperators: false,
      showOnlySelectedArrivalPostalOperators: false,
      showSaveSelectionModal: false,
      saveSelectionCheckedUnlocodes: [],
      saveSelectionSelections: [],
    };
  }

  componentDidMount() {
    this.props.setDirections({
      directions: this.props.children.report.reportDirections,
    });

    this.props.retrieveOutboundPostalOperatorsUnlocodeRequestActionCreator(
      {
        defaultDirection: this.getDefaultDirection(),
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      },
      this.props.children.report,
      this.props.departureCheckedUnlocodes,
    );

    this.props.retrieveInboundPostalOperatorsUnlocodeRequestActionCreator(
      {
        defaultDirection: this.getDefaultDirection(),
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      },
      this.props.children.report,
      this.props.arrivalCheckedUnlocodes,
    );
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    await this.props.selectedDeparturePostalOperatorsNodes;
    // eslint-disable-next-line max-len
    if (this.state.firstDeparture && this.props.departurePostalOperatorsNodes === nextProps.departurePostalOperatorsNodes && nextProps.selectedDeparturePostalOperatorsNodes.length !== 0) {
      this.setState({
        firstDeparture: false,
        showOnlySelectedDeparturePostalOperators: true,
      });
    }

    await this.props.selectedArrivalPostalOperatorsNodes;
    // eslint-disable-next-line max-len
    if (this.state.firstArrival && this.props.arrivalPostalOperatorsNodes === nextProps.arrivalPostalOperatorsNodes && nextProps.selectedArrivalPostalOperatorsNodes.length !== 0) {
      this.setState({
        firstArrival: false,
        showOnlySelectedArrivalPostalOperators: true,
      });
    }

    await this.props.departurePostalOperatorsNodes;
    this.setState({
      departureSelectionTreeLoaded: this.props.departurePostalOperatorsNodes.length > 0,
    });

    await this.props.arrivalPostalOperatorsNodes;
    this.setState({
      arrivalSelectionTreeLoaded: this.props.arrivalPostalOperatorsNodes.length > 0,
    });
  }

  onSelectAllDeparturePostalOperators = () => {
    this.props.onSelectAllDepartureUnlocodes(this.props.departurePostalOperatorsNodes);
  };

  onSelectAllArrivalPostalOperators = () => {
    this.props.onSelectAllArrivalUnlocodes(this.props.arrivalPostalOperatorsNodes);
  };

  onDeSelectAllDeparturePostalOperators = () => {
    this.setState({
      showOnlySelectedDeparturePostalOperators: false,
    });
    this.props.onDeSelectAllDepartureUnlocodes();
  };

  onDeSelectAllArrivalPostalOperators = () => {
    this.setState({
      showOnlySelectedArrivalPostalOperators: false,
    });
    this.props.onDeSelectAllArrivalUnlocodes();
  };

  onSelectDeparturePostalOperatorOrUnlocode = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    } else {
      this.setState({
        firstDeparture: false,
      });
    }
    this.props.departureUnlocodeCheckedActionCreator(selected, this.props.children.report);
  };

  onSelectArrivalPostalOperatorOrUnlocode = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedArrivalPostalOperators: false,
      });
    } else {
      this.setState({
        firstArrival: false,
      });
    }
    this.props.arrivalUnlocodeCheckedActionCreator(selected, this.props.children.report);
  };

  onExpandDeparturePostalOperator = (expanded) => {
    this.props.onDeparturePostalOperatorExpanded(expanded);
  };

  onExpandArrivalPostalOperator = (expanded) => {
    this.props.onArrivalPostalOperatorExpanded(expanded);
  };

  onToggleShowOnlySelectedDeparturePostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators: !this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  onToggleShowOnlySelectedArrivalPostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators: !this.state.showOnlySelectedArrivalPostalOperators,
    });
  };

  onSwitchInboundOutbound = () => {
    this.props.setDirectionFlag({
      switched: !this.props.isDirectionsSwitched,
    });
    this.props.switchDepartureArrival({
      departure: {
        checkedUnlocodes: this.props.departureCheckedUnlocodes,
        expandedPostalOperators: this.props.departureExpandedPostalOperators,
        nodes: this.props.departurePostalOperatorsNodes,
      },
      arrival: {
        checkedUnlocodes: this.props.arrivalCheckedUnlocodes,
        expandedPostalOperators: this.props.arrivalExpandedPostalOperators,
        nodes: this.props.arrivalPostalOperatorsNodes,
      },
    });
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators: this.state.showOnlySelectedArrivalPostalOperators,
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators: this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  getDefaultDirection() {
    let defaultDirection = this.props.children.report.reportDirections[0];
    if (this.props.isDirectionsSwitched) {
      defaultDirection = defaultDirection === DirectionTypes.INBOUND ?
        DirectionTypes.OUTBOUND : DirectionTypes.INBOUND;
    }
    return defaultDirection;
  }

  openSaveSelectionModalForDeparture = () => {
    this.openSaveSelectionModal({
      checkedUnlocodes: createUnlocodePresetSelectionsOnSave(this.props.departureCheckedUnlocodes, this.props.departurePostalOperatorsNodes),
      selections: this.props.departureSelections,
    });
  };

  openSaveSelectionModalForArrival = () => {
    this.openSaveSelectionModal({
      checkedUnlocodes: createUnlocodePresetSelectionsOnSave(this.props.arrivalCheckedUnlocodes, this.props.departurePostalOperatorsNodes),
      selections: this.props.arrivalSelections,
    });
  };

  openSaveSelectionModal = ({ checkedUnlocodes, selections }) => {
    this.setState({
      showSaveSelectionModal: true,
      saveSelectionCheckedUnlocodes: checkedUnlocodes,
      saveSelectionSelections: selections,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name, checkedUnlocodes }) => {
    this.props.saveUserUnlocodeSelectionRequestActionCreator(
      name,
      checkedUnlocodes,
    );
    this.closeSaveSelectionModal();
  };

  render() {
    const tempDepartureNodes = [
      {
        value: 'DUMMY',
        label: 'LOADING...',
        expandDisabled: true,
        children: this.props.departureCheckedUnlocodes.map(initialItem => ({ value: initialItem, label: '' })),
      }];
    const tempArrivalNodes = [
      {
        value: 'DUMMY',
        label: 'LOADING...',
        expandDisabled: true,
        children: this.props.arrivalCheckedUnlocodes.map(initialItem => ({ value: initialItem, label: '' })),
      }];

    const departurePostalOperatorSelectorProps = {
      selected: this.props.departureCheckedUnlocodes,
      expanded: !this.state.departureSelectionTreeLoaded ? [] : this.props.departureExpandedPostalOperators,
      expandDisabled: !this.state.departureSelectionTreeLoaded ? true : this.props.children.report.locationType === LocationTypes.OPERATOR,
      isShowOnlySelected: !this.state.departureSelectionTreeLoaded ? true : this.state.showOnlySelectedDeparturePostalOperators,
      // eslint-disable-next-line no-nested-ternary
      postalOperatorNodes: !this.state.departureSelectionTreeLoaded ? tempDepartureNodes : this.state.showOnlySelectedDeparturePostalOperators ?
        this.props.selectedDeparturePostalOperatorsNodes : this.props.departurePostalOperatorsNodes,
      originalPostalOperatorNodes: !this.state.departureSelectionTreeLoaded ? tempDepartureNodes : this.props.departurePostalOperatorsNodes,
      onSelect: !this.state.departureSelectionTreeLoaded ? noop : this.onSelectDeparturePostalOperatorOrUnlocode,
      onExpand: !this.state.departureSelectionTreeLoaded ? noop : this.onExpandDeparturePostalOperator,
      onSelectAll: !this.state.departureSelectionTreeLoaded ? noop : this.onSelectAllDeparturePostalOperators,
      onDeSelectAll: !this.state.departureSelectionTreeLoaded ? noop : this.onDeSelectAllDeparturePostalOperators,
      onShowOnlySelected: !this.state.departureSelectionTreeLoaded ? noop : this.onToggleShowOnlySelectedDeparturePostalOperators,
      openSaveSelectionModal: !this.state.departureSelectionTreeLoaded ? noop : this.openSaveSelectionModalForDeparture,
    };

    const arrivalPostalOperatorSelectorProps = {
      selected: this.props.arrivalCheckedUnlocodes,
      expanded: !this.state.arrivalSelectionTreeLoaded ? [] : this.props.arrivalExpandedPostalOperators,
      expandDisabled: !this.state.arrivalSelectionTreeLoaded ? true : this.props.children.report.locationType === LocationTypes.OPERATOR,
      isShowOnlySelected: !this.state.arrivalSelectionTreeLoaded ? true : this.state.showOnlySelectedArrivalPostalOperators,
      // eslint-disable-next-line no-nested-ternary
      postalOperatorNodes: !this.state.arrivalSelectionTreeLoaded ? tempArrivalNodes : this.state.showOnlySelectedArrivalPostalOperators ?
        this.props.selectedArrivalPostalOperatorsNodes : this.props.arrivalPostalOperatorsNodes,
      originalPostalOperatorNodes: !this.state.arrivalSelectionTreeLoaded ? tempArrivalNodes : this.props.arrivalPostalOperatorsNodes,
      onSelect: !this.state.arrivalSelectionTreeLoaded ? noop : this.onSelectArrivalPostalOperatorOrUnlocode,
      onExpand: !this.state.arrivalSelectionTreeLoaded ? noop : this.onExpandArrivalPostalOperator,
      onSelectAll: !this.state.arrivalSelectionTreeLoaded ? noop : this.onSelectAllArrivalPostalOperators,
      onDeSelectAll: !this.state.arrivalSelectionTreeLoaded ? noop : this.onDeSelectAllArrivalPostalOperators,
      onShowOnlySelected: !this.state.arrivalSelectionTreeLoaded ? noop : this.onToggleShowOnlySelectedArrivalPostalOperators,
      openSaveSelectionModal: !this.state.arrivalSelectionTreeLoaded ? noop : this.openSaveSelectionModalForArrival,
    };

    const selectionCriteria = this.props.children.report.selectionCriteria.items;
    const SC_CODE = sc.SC021;
    const nextSelectionCriteriaRouteName = (
      scDefinitions[selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]] || {}
    ).routeName;
    /* eslint-disable react/jsx-indent */
    return (
      <div className="operator-selector-wrapper">
        {this.state.showSaveSelectionModal &&
        <SaveUnlocodeSelectionModal
          saveSelection={this.saveSelection}
          closeModal={this.closeSaveSelectionModal}
          checkedUnlocodes={this.state.saveSelectionCheckedUnlocodes}
          selections={this.state.saveSelectionSelections}
        />
        }
        <div className="operator-sidebar">
          <PostalOperatorSelectionSidebarContainer
            operatorType={OperatorTypes.DEPARTURE}
            operators={departurePostalOperatorSelectorProps.originalPostalOperatorNodes}
            report={this.props.children.report}
          />
        </div>

        <div className="operators">
          <div className="operators-selection-panel">
            <div className="operator">
              <PostalOperatorSelector
                title="DEPARTURE"
                {...departurePostalOperatorSelectorProps}
              />
            </div>
            <div className="operator-divider">
              {this.props.directions.directionSwitchEnabled &&
              <FloatingActionButton
                onClick={this.onSwitchInboundOutbound}
                backgroundColor="#03adaa"
                mini
                style={{
                    zIndex: 1,
                    marginLeft: '-20px',
                    marginTop: '11px',
                    border: '5px solid #abe1e5',
                    boxShadow: 'none',
                  }}
              >
                <ActionCode />
              </FloatingActionButton>
              }
            </div>
            <div className="operator">
              <PostalOperatorSelector
                title="ARRIVAL"
                {...arrivalPostalOperatorSelectorProps}
              />
            </div>
          </div>

          {this.props.directions.directionSwitchEnabled && <div className="inbound-outbound">{this.props.isDirectionsSwitched ? 'Outbound' : 'Inbound'}</div>}

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>

        <div className="operator-sidebar">
          <PostalOperatorSelectionSidebarContainer
            operatorType={OperatorTypes.ARRIVAL}
            operators={arrivalPostalOperatorSelectorProps.originalPostalOperatorNodes}
            report={this.props.children.report}
          />
        </div>
      </div>);
  }
}

TargetNodeUnlocodeWizardContainer.propTypes = {
  report: PropTypes.shape({
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
  }),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  retrieveOutboundPostalOperatorsUnlocodeRequestActionCreator: PropTypes.func,
  retrieveInboundPostalOperatorsUnlocodeRequestActionCreator: PropTypes.func,
  selectedDeparturePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departureCheckedUnlocodes: PropTypes.arrayOf(PropTypes.string),
  departureExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  departureSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    unlocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  selectedArrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalCheckedUnlocodes: PropTypes.arrayOf(PropTypes.string),
  arrivalExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  arrivalSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    unlocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  saveUserUnlocodeSelectionRequestActionCreator: PropTypes.func,
  departureUnlocodeCheckedActionCreator: PropTypes.func,
  onDeparturePostalOperatorExpanded: PropTypes.func,
  onSelectAllDepartureUnlocodes: PropTypes.func,
  onDeSelectAllDepartureUnlocodes: PropTypes.func,
  arrivalUnlocodeCheckedActionCreator: PropTypes.func,
  onArrivalPostalOperatorExpanded: PropTypes.func,
  onSelectAllArrivalUnlocodes: PropTypes.func,
  onDeSelectAllArrivalUnlocodes: PropTypes.func,
  directions: PropTypes.shape({
    defaultDirection: PropTypes.string,
    directionSwitchEnabled: PropTypes.bool,
    switched: PropTypes.bool,
  }),
  setDirections: PropTypes.func,
  isDirectionsSwitched: PropTypes.bool,
  switchDepartureArrival: PropTypes.func,
  setDirectionFlag: PropTypes.func,
  // eslint-disable-next-line react/no-typos
  startDate: momentPropTypes.momentObj,
  // eslint-disable-next-line react/no-typos
  endDate: momentPropTypes.momentObj,
  /* eslint-enable react/no-typos */
};

/* Needed for prop-types with cloneElement */
export const ConnectedTargetNodeUnlocodeWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TargetNodeUnlocodeWizardContainer);

export default (ConnectedTargetNodeUnlocodeWizardContainer);
